import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Typography, CircularProgress, LinearProgress } from '@mui/material';
import colors from '../../../scss/colors';

function Iframe(props) {
  const { src, width, height } = props;
  const [loading, setLoading] = useState(true);

  return (
    <>
      {loading && (
        <>
          <LinearProgress
              variant="indeterminate"
              color="inherit"
              sx={{
                  m: 1,
                  width: "100%",
                  position: "absolute",
                  top: "57px",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: colors.LIGHTER_BLUE,
                  "& .MuiLinearProgress-bar": {
                      backgroundColor: colors.LIGHT_BLUE,
                  },
              }}
          />
          <Box
            sx={{
              m: 1,
              position: "absolute",
              top: "120px",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100%",
            }}
          >
            <div className="flex justify-center items-center text-navy-blue font-medium text-xl relative z-10 animate-pulse w-full">
              Loading Onboarding Experience...
            </div>
          </Box>
        </>
      )}
      <iframe
        src={src}
        style={{ width: loading ? '0px' : '100%', height: loading ? '0px' : '100vh', position: 'relative', zIndex: 9999 }}
        title="onboarding-portal"
        onLoad={() => setLoading(false)}
        sandbox="allow-forms allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
      />
    </>

  );
}
export default Iframe;